import { ColorPreset } from '@core/models';

import { ColorSwatchDto } from './color-palette.dto';

/**
 * The only translation between the colour-palette wire shape and the app model.
 * The two happen to line up field for field today; the mapper exists anyway so a
 * rename on either side stops here instead of walking into every template.
 */
export function colorPresetsFromDto(dto: ColorSwatchDto[]): ColorPreset[] {
  return dto.map((s) => ({ colorGuid: s.colorGuid, label: s.label, hex: s.hex }));
}
